<form name="formGroup" [formGroup]="formGroup" class="rollover-settings-dialog">
    <div mat-dialog-content>
        <h2 class="input-field-dialog-title">Set data rollover period for {{selectedDataSourceDataToBeSet?.length}}
            districts</h2>

        <ngc-data-rollover-setting [settings]="dataRolloverSettings"
                                   [isPreviewDialog]="true"
                                   [onSave$]="onSave$"
                                   (cancelEdit)="onClose()"
                                   (saveDataRolloverSettings)="onSaveDialog($event)"
        >
        </ngc-data-rollover-setting>


        <div class="mt-20">
            <mat-checkbox [formControl]="overwriteCtrl">
                <span>Overwrite existing settings</span>
            </mat-checkbox>
        </div>

        <div class="mt-20">
            <mat-slide-toggle [checked]="true" [disabled]="true">
                Exclude districts with LMS integrations
            </mat-slide-toggle>
        </div>

    </div>

    <mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
        <button mat-button
                type="button"
                (click)="onClose()"
                class="mr-8"
                tabindex="12"
        >
            Cancel
        </button>

        <button mat-raised-button
                color="primary"
                type="submit"
                (click)="onClickSave()"
                [disabled]="formGroup?.invalid"
        >
            Proceed to preview changes
        </button>
    </mat-dialog-actions>
</form>
